import { render, staticRenderFns } from "./NewProfileForm.vue?vue&type=template&id=709dbf82&"
import script from "./NewProfileForm.vue?vue&type=script&lang=js&"
export * from "./NewProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./NewProfileForm.vue?vue&type=style&index=0&id=709dbf82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports